import React from 'react';

import { Piwik, SiteCoreDictionary } from '@eika-kortbetjening/types';

import fallbackDictionary from '../fallback-dictionary';
import CardFunctionalityButtons from './CardFunctionalityButtons';
import { AdministrateCardLink, ChangeCreditLimitLink, ValueProgramLink } from './CardFunctionalityLinks';

import './CardFunctionality.scss';

interface CardFunctionalityProps {
    /** Function called when press administrate card link */
    administrateCardRedirect: () => void;
    /** Function called when press change credit limit link */
    changeCreditLimitRedirect: () => void;
    /** Optional additional class names */
    className?: string;
    /** Function called when press extra payment button */
    extraPaymentRedirect: () => void;
    /** Whether change credit limit button should be visible */
    hasAccessChangeCreditLimit: boolean;
    /** If the card is a business card */
    isCorporateCard: boolean;
    /** Function called when press money transfer button */
    moneyTransferRedirect?: () => void;
    /** Whether user is high fraud risk */
    userIsHighFraudRisk?: boolean;
    /** Function called when press value program link */
    valueProgramRedirect?: () => void;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** PIWIK tags */
    piwik?: Piwik;
}

const CardFunctionality = (props: CardFunctionalityProps) => {
    const dictionary = { ...fallbackDictionary, ...props.sitecoreDictionary };

    return (
        <div className={`card-balance-transaction-list__functionality ${props.className ?? ''}`}>
            <CardFunctionalityButtons
                dictionary={dictionary}
                extraPaymentRedirect={props.extraPaymentRedirect}
                isCorporateCard={props.isCorporateCard}
                moneyTransferRedirect={props.moneyTransferRedirect}
                userIsHighFraudRisk={props.userIsHighFraudRisk}
                piwik={props.piwik}
            />
            <AdministrateCardLink
                dictionary={dictionary}
                administrateCardRedirect={props.administrateCardRedirect}
                piwik={props.piwik}
            />
            <ChangeCreditLimitLink
                dictionary={dictionary}
                changeCreditLimitRedirect={props.changeCreditLimitRedirect}
                hasAccessChangeCreditLimit={props.hasAccessChangeCreditLimit}
                piwik={props.piwik}
            />
            <ValueProgramLink
                dictionary={dictionary}
                valueProgramRedirect={props.valueProgramRedirect}
                piwik={props.piwik}
            />
        </div>
    );
};

export default CardFunctionality;
